import classNames from 'classnames';

import React, { forwardRef, ForwardRefExoticComponent, HTMLAttributes, RefAttributes } from 'react';

import styles from './tab-bar.scss';

type Props = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    dataTestId?: string;
  };

const COMPONENT_ID = 'modulor-tab-bar';

export const TabBar: ForwardRefExoticComponent<Props> = forwardRef<HTMLDivElement, Props>(
  ({ children, className, ...rest }, ref, dataTestId = COMPONENT_ID) => {
    return (
      <div
        data-testid={dataTestId}
        data-id={dataTestId}
        data-component-name={COMPONENT_ID}
        ref={ref}
        className={classNames(className, styles.layout)}
        {...rest}>
        {children}
      </div>
    );
  },
);

TabBar.displayName = 'TabBar';
